import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resume-details',
  templateUrl: './resume-details.component.html',
  styleUrls: ['./resume-details.component.scss']
})
export class ResumeDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
